import React from 'react';

const Blog = () => {
    return (
        <div className='container my-5'>

            <div className="row">
                <div className="col-12 text-start">
                    <h2 className='text-center'>BACKEND BLOG</h2>
                    <h2>CRUD Operations</h2>
                    <p>CRUD stands for CREATE, READ, UPDATE, DELETE. CRUD is a  set of operations we get servers to execute (POST, GET, PUT and DELETE requests respectively). </p>
                    <ul>
                        <li>CREATE (POST)= Make something
                        </li>
                        <li>READ(GET)=Get something
                        </li>
                        <li>UPDATE(PUT)=Change something
                        </li>
                        <li>DELETE (DELETE)- Remove something</li>
                    </ul>
                    <h2>JWT</h2>
                    <p>JWT stands for Json Web Token. JWT is a method for representing claims securely between two parties.
                    </p>
                    <h2>Mongoose </h2>
                    <p>Mongoose is a MongoDB and Node.js Object Data Modeling (ODM) module. It manages data associations, does schema validation, and is used to translate between objects in code and their MongoDB representations.
                    </p>
                    <h2>Relational database (MySql)
                    </h2>
                    <p>A relational database organizes data into one or more data tables where data types can be associated with one another, allowing the data to be structured.</p>
                    <h2>Aggregation
                    </h2>
                    <p>Aggregation basically is the process that is used for combining entities to form a single meaningful entity.
                    </p>
                    <h2>Express</h2>
                    <p>Express is a back end web application framework for Node.js. We can easily perform CRUD operations in NODE by using Express. Basically Express makes CRUD operations much easier than Raw Node.
                    </p>
                    <h2>Node</h2>
                    <p>Node js is an open-source, cross-platform, server-side JavaScript runtime environment.</p>

                </div>
                <div className="col-12 text-start">
                    <h2 className='text-center'>REACT JS BLOG</h2>
                    <h3>1. PropTypes</h3>
                    <p >PropTypes validate our types of prop. Like when we send props from one component to other components we actually don’t check what type of data we are sending or getting in this case PropTypes help us to validate the data type.
                    </p>

                    <h3>2. JSX</h3>
                    <p> JSX stands for JavaScript XML. We can write HTML elements inside JavaScript by the help of JSX.
                    </p>
                    <h3>3. Component Lifecycle</h3>
                    <p>React component lifecycle has three phases. They are Mounting, Updating and Unmounting</p>
                    <h5>Mounting</h5>
                    <p>Mounting means putting elements into the DOM. Four methods are called during mounting. They are
                    </p>
                    <ul>
                        <li>constructor()
                        </li>
                        <li>static getDerivedStateFromProps()
                        </li>
                        <li>render()
                        </li>
                        <li>componentDidMount()
                        </li>
                    </ul>
                    <h5> Updating</h5>
                    <p>Props and states are changed caused by updating. These methods are called during updating
                    </p>
                    <ul>
                        <li>
                            static getDerivedStateFromProps()
                        </li>
                        <li>
                            shouldComponentUpdate()

                        </li>
                        <li>
                            render()

                        </li>
                        <li>
                            getSnapshotBeforeUpdate()
                        </li>
                        <li>
                            componentDidUpdate()
                        </li>
                    </ul>
                    <h5> Unmounting</h5>
                    <p>Components are removed from the Dom caused by Unmounting. Only <b>componentWillUnmount()</b> this method is called during Unmounting.
                    </p>
                    <h3>4. Hooks</h3>
                    <p>Basically we use hooks in functional components and Hooks allow function components to have access to state and other React features. Examples of hooks are useState, useEffect, useRef, useLocation, useHistory(v5), useNavigation(v6) etc.
                    </p>
                    <h3>5. Custom hooks</h3>
                    <p>when we want to share a component’s data with other components in our project we can create a custom hook. Custom hook’s name starts with “use”. For example if I want to create context in my project I can do it like useContext.
                    </p>
                    <h3>6. Context API</h3>
                    <p> Context api provides a way to share data from one component to another component without having to pass props down manually at every level.
                    </p>
                    <h3>7. Virtual DOM and diffing- algorithm</h3>
                    <p>Virtual DOM is a DOM, which can be synced with real dom and represent the real dom.</p>
                    <h3>8. Optimization of react js application</h3>
                    <p>when we send data using  props from one components to another components we can use “key” for better performance and we can also use memoize to optimize react application
                    </p>
                </div>

            </div>
        </div>
    );
};

export default Blog;